// @flow
import $ from 'jquery';
import JQueryView, { on } from '../common/JQueryView';

export default class NotFoundPageView extends JQueryView {
  constructor() {
    super('body');
  }

  @on({ event: 'click', selector: '.circle-mark' })
  clickToggleAccordion(e: any) {
    const circleMark = $(e.currentTarget);
    const openTarget = circleMark.parent();

    circleMark.text() === '＋' ? circleMark.text('ー') : circleMark.text('＋');
    openTarget.find('.question-title').toggleClass('font-weight-bold');
    openTarget.next().toggleClass('d-none');
  }
}
